import { useState, useEffect } from "react";
import moment from "moment";
import { sortBy } from "lodash";

const defaultPageSize = 250;

const useGigs = ({
  inPast = false,
  pageSize: initialPageSize = defaultPageSize,
}) => {
  const [loading, setLoading] = useState(true);
  const [gigs, setGigs] = useState([]);

  const [pageSize, setPageSize] = useState(initialPageSize);
  const [totalGigs, setTotalGigs] = useState(0);
  const timeBoundary = inPast ? "timeMax" : "timeMin";

  const CAL_ID =
    "c9ebdc483ad3f2482a878bf51b07f532376369f9463a5ba6534f750a9108c088@group.calendar.google.com";
  const API_KEY = "AIzaSyAuzUPbM7QeWIqa85aDF48KCRG4lLUTaTs";

  useEffect(() => {
    // https://developers.google.com/calendar/api/v3/reference/events/list
    fetch(
      `https://www.googleapis.com/calendar/v3/calendars/${CAL_ID}/events?key=${API_KEY}&${timeBoundary}=${moment()
        .tz("America/Los_Angeles")
        .startOf("day")
        .format()}&timeZone=America/Los_Angeles&orderBy=startTime&singleEvents=true`
    )
      .then((response) => response.json())
      .then((data) => {
        let sortedGigs = data.items;
        // let sortedGigs = sortBy(data.items, (a) => a?.start?.dateTime);
        if (inPast) {
          sortedGigs = sortedGigs.reverse().slice(0, pageSize);
        }
        setGigs(sortedGigs);
        setTotalGigs(data.items.length);
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [pageSize]);

  const showMore = (size) => {
    setPageSize(size);
  };

  return { gigs, loading, showMore, totalGigs, updatePageSize: setPageSize };
};

export default useGigs;
